import React from 'react';
import RequestForm from '../components/sections/RequestForm';
import PageHeader from '../components/ui/PageHeader';
import './StaticPage.css';

const RequestPage: React.FC = () => (
  <div className="static-page">
    <PageHeader page="request" />
    <RequestForm />
  </div>
);

export default RequestPage;
